<template>
  <router-view/>
</template>
<style>
div, span, p {
    caret-color: transparent;
}
</style>

